/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Injectable } from '@angular/core';
import { Util } from 'src/refresh/service/Util';
import { Confirm } from '../../../refresh/service/constant';

@Injectable({
  providedIn: 'root',
})

export class ItemList  {

      public  countryList    : Map<string,string>;
      public  isoCountryList : Map<string,string>;
      public  provinceList   : Map<string,string>;
      public  provinceListForAddr  : Map<string,string>;
      public  cityList       : Map<string,string>;
      public  regionList     : Map<string,string>;

      public  categoryList     : Map<string,string>;
      public  categoryDescList : Object;
      public  promoterList     : Object;
      
      public  geoCodeList : Object;
      public  geoCodeNameList : Object;
      public  facilityList   : Object; ///Map<string,Facility>;

      ///public  jurisdictionList : Array<Jurisdiction>;
      ///public  divisionRegistrarMap : Object;  // [number:Date]; 
      public  productFeeList       : Map<string,string>;  // [number: number];

      public hospitalList:    Object;   // city: Object(Hospital)
      public birthCenterList: Object;   // city: Object(BirthCenter)

      public  parentTypes: Map<string,string> = new Map();
      public  monthList:   Map<string,string> = new Map();
      public  yesNoList:   Map<string,string> = new Map();
      public  birthTypes:  Map<string,string> = new Map();
      public  birthOrders: Map<string,string> = new Map();
      public  parentCount: Map<number,string> = new Map();
      public  parentCnt:   Map<number,string> = new Map();
      public  maritalStatus: Map<string,string> = new Map();

      public  deliveryList: Map<string,string> = new Map();
      
      public  addressList:  Map<string,string> = new Map();
      
      public  birthPlaces: Map<string,string> = new Map();
      public  genders:     Map<string,string> = new Map();
      public  attendants:  Map<string,string> = new Map();

      public  contactMethodList:  Map<string,string> = new Map();
      public  contactTimeList:  Map<string,string> = new Map();
      public  langList:     Map<string,string> = new Map();
      public  subjectList:  Map<string,string> = new Map();

      public  titleList: Map<string,string> = new Map();  // url = title

      public  select:string = "";

      public  NotFoundDesc:string;

      public dateFormat(theDate:string) :string {
            let  values = theDate.split("-");

            if ( values.length == 3 ) {
                 let yy = values[0];
                 let mm = values[1];
                 let dd = values[2];

                 return this.monthList.get(mm) + " " + dd + ", " + yy;
            }
            return theDate;
      }

      public setLangChange(shared:Object, project:Object) {

            let month       = shared['date'];
            let select      = shared['select'];
            let birthTypes  = shared['birthType'];
            let birthOrders = shared['birthOrder'];
            let parentTypes = shared['parentType'];
            let count       = shared['count'];
            let cnt         = shared['cnt'];

            let maritalStatus = shared['maritalStatus'];
            let deliveryList  = shared['delivery'];
            let addressList   = shared['address'];
            let subjectList   = shared['subjectList'];
            
            let birthPlaces = shared['birthPlace'];
            let genders     = shared['gender'];
            let attendants  = shared['attendant'];
            let contactMethodList = project['contactMethodList'];
            let contactTimeList = project['contactTimeList'];
            let langList    = project['langList'];

            

            this.NotFoundDesc = shared['notFound'];

            for ( let i = 1 ; i <= 12; i++ ) {
                  this.monthList.set(Util.padZero(String(i),2),month[i]);
            }

            for ( let i = 1 ; i <= 5;  i++ ) this.birthTypes.set(String(i),birthTypes[i]);
            for ( let i = 1 ; i <= 5;  i++ ) this.birthOrders.set(String(i),birthOrders[i]);
            for ( let i = 1 ; i <= 3;  i++ ) this.parentTypes.set(''+i,parentTypes[i]);
            for ( let i = 1 ; i <= 4;  i++ ) this.parentCount.set(i,count[i]);
            for ( let i = 1 ; i <= 4;  i++ ) this.parentCnt.set(i,cnt[i]);

            for ( let x in maritalStatus ) this.maritalStatus.set(x,maritalStatus[x]); 
            for ( let x in deliveryList )  this.deliveryList.set(x,deliveryList[x]); 
            for ( let x in addressList )   this.addressList.set(x,addressList[x]); 
            for ( let x in subjectList )   this.subjectList.set(x,subjectList[x]); 

            for ( let x in birthPlaces )  this.birthPlaces.set(x,birthPlaces[x]); 
            for ( let x in genders )      this.genders.set(x,genders[x]); 
            for ( let x in attendants )   this.attendants.set(x,attendants[x]); 

            let keys = Object.keys(contactMethodList);
            for ( let i = keys.length-1; i >=0; i-- ) {
                  this.contactMethodList.set(keys[i],contactMethodList[keys[i]]); 
            }
            
            for ( let x in contactTimeList )   this.contactTimeList.set(x,contactTimeList[x]); 
            for ( let x in langList )          this.langList.set(x,langList[x]); 

            this.yesNoList.set(Confirm.YES,select['yes']);
            this.yesNoList.set(Confirm.NO,select['no']);

            this.select = select["one"];
      }
}

//-----------------------------------------------------------

export interface Facility {
       facilityCode:string;     
       facilityName:string;     
       streetNumber:string;     
       streetName:string;     
       postalCode:string;     
       effectiveDate:Date;     
}
 
export interface Jurisdiction {
       jurisdictionName: string;
       region: string;
       dr_code: number;
       po_box: number;
       rr_num: number;
       address: string;
       city: string;
       postalCode: string;
       phone: string;
       fax: string;
       doRegisterBirth: string;
       registrationFee: number;
}



